import script from "./ImageDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./ImageDeleteModal.vue?vue&type=style&index=0&id=36e6e00f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36e6e00f"]])

export default __exports__